const specialCommissions = {
	"LUNGHITANO SANTIAGO": ["12% de capital"],
	"COVELLI FRANCISCO": ["12% de capital"],
	FINGURU: ["5% de capital"],
	"RIVAROLA PAOLA": ["13% de capital"],
	FINMARVI: ["13% de capital"],
	"STABILE JORGELINA ROSA": ["13% de capital"],
	"SUC. FEDALAK": ["8% de capital"],
	"IBARRA JUAN": [
		"-Hasta $ 9.000.000 de capital 8%",
		"-Desde $ 9.000.001 hasta $ 12.000.000 de capital 10%",
		"-En adelante 12%",
	],
};

const defaultCommission = [
	"-Hasta $ 9.000.000 de capital 7%",
	"-Desde $ 9.000.001 hasta $ 12.000.000 de capital 9%",
	"-En adelante 11%",
];

const normalize = (str) => str.trim().toUpperCase();

export const getCommissionDisplay = (supplierName) => {
	const normalizedSupplierName = normalize(supplierName);
	return specialCommissions[normalizedSupplierName] || defaultCommission;
};